import Image from 'next/future/image';
import { FormattedMessage } from 'react-intl';

import { fiterWithSize, isPopularData } from '@/helper/filterlogicInfo';
import minusIcon from '@/public/images/icons/minus.svg';
import plusIcon from '@/public/images/icons/plus.svg';

import SingleUnitCard from './single-unit-card';

const UnitSection = (props: any) => {
  const {
    unitsData,
    unitsHeading,
    checkName,
    featuredChecked,
    onCheckBoxClick,
    unitsSubHeading,
  } = props;
  const filteredUnits = fiterWithSize(unitsData);
  const popularUnits = isPopularData(filteredUnits);
  return (
    <>
      {filteredUnits &&
      filteredUnits?.length &&
      ((featuredChecked && popularUnits.length) || !featuredChecked) ? (
        <div className="sv-units-details">
          <div className="row justify-content-between align-items-center title-container">
            <div className="col-lg-auto col-md-auto col-sm-12 d-flex gap-1 align-items-center">
              <h2 className="units-size-titles">{unitsHeading}</h2>
              {unitsSubHeading && (
                <div className="units-size-subtitles">{unitsSubHeading}</div>
              )}
            </div>

            <div className="col-lg-auto col-md-auto col-sm-12 text-end">
              {/* {featuredChecked && (
                <button
                  onClick={() =>
                    onCheckBoxClick({
                      target: { value: checkName, checked: true },
                    })
                  }
                  className="expand-list-btn"
                  value={checkName}
                >
                  <FormattedMessage id="buttons.seeMore" />
                  <Image
                    src={plusIcon}
                    alt="plus-icon"
                    className="plus-icon"
                    width="30"
                    height="30"
                  />
                </button>
              )} */}
            </div>
          </div>

          <div className="unit-details-table">
            {/* <table className="table table-borderless">
              <tbody> */}
            {filteredUnits &&
              filteredUnits.length &&
              popularUnits &&
              (!featuredChecked
                ? filteredUnits.map((item: any, index: any) => {
                    return <SingleUnitCard key={index} item={item} />;
                  })
                : popularUnits?.slice(0, 2).map((item: any, index: any) => {
                    return <SingleUnitCard key={index} item={item} />;
                  }))}
            {/* </tbody>
            </table> */}
          </div>
          {featuredChecked && (
            <div className="col-lg-auto col-md-auto col-sm-12 text-end">
              <button
                onClick={() =>
                  onCheckBoxClick({
                    target: { value: checkName, checked: true },
                  })
                }
                className="expand-list-btn"
                value={checkName}
              >
                <FormattedMessage id="buttons.seeMore" />
                <Image
                  src={plusIcon}
                  alt="plus-icon"
                  className="plus-icon"
                  width="30"
                  height="30"
                />
              </button>
            </div>
          )}
          {!featuredChecked && (
            <div className="col-lg-auto col-md-auto col-sm-12 text-end">
              <button
                onClick={() =>
                  onCheckBoxClick({
                    target: { value: 'Featured', checked: true },
                  })
                }
                className="expand-list-btn"
                value={checkName}
              >
                <FormattedMessage id="buttons.less" />
                <Image
                  src={minusIcon}
                  alt="minus-icon"
                  className="plus-icon"
                  width="30"
                  height="30"
                />
              </button>
            </div>
          )}
        </div>
      ) : null}
    </>
  );
};

export default UnitSection;
